import { supabase } from '@/lib/supabase';

export const pingDatabase = async () => {
  try {
    const { error } = await supabase.from('users').select('id').limit(1);
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('❌ Database keepalive failed:', error);
    return false;
  }
};

// Ping toutes les 6 heures quand l'application est ouverte
if (typeof window !== 'undefined') {
  setInterval(pingDatabase, 6 * 60 * 60 * 1000);
  // Ping initial
  pingDatabase();
}